import React from 'react'
import { ContentTypography, Icon, OverMap, TitleTypography } from './styles'
import { WereHiringProps } from 'src/types'

export function MapSection(props: WereHiringProps) {
    const { icon, title, content } = props
    return (
        <OverMap marginBottom={['xxmedium', 'xxmedium', 'xxmedium', 0]}>
            <Icon src={icon} alt={title} />
            <TitleTypography
                variant={'h2'}
                fontSize={['xmedium', 'xmedium', 'xxxmedium', 'xxxmedium']}
                fontWeight={700}
            >
                {title}
            </TitleTypography>
            <ContentTypography
                variant={'h3'}
                fontSize={['xxsmall', 'xxsmall', 'medium', 'medium']}
                fontWeight={400}
            >
                {content}
            </ContentTypography>
        </OverMap>
    )
}
